module.exports = __webpack_public_path__ + "assets/img/Inter-Bold.svg?b975a268ddb6c0e23eb84c7e2cae857b";